import { connect } from 'react-redux'
import { compose, lifecycle, withHandlers, withState } from 'recompose'
// import { bindActionCreators } from 'redux'
// import { webFetchPartners } from 'actions/Partners'
// import { fetchWebSlideshow } from 'actions/Slideshow'
import SatuanPendidikans from 'components/publicPages/satuanPendidikan'
import { bindActionCreators } from 'redux'
import { ShootTracker } from 'actions/Tracker'
import Cookies from 'js-cookie'

const mapStateToProps = () => ({})

const mapDispatchToProps = (dispatch) => ({
  // webFetchPartners: bindActionCreators(webFetchPartners, dispatch),
  // fetchWebSlideshow: bindActionCreators(fetchWebSlideshow, dispatch)
  ShootTracker: bindActionCreators(ShootTracker, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  // withState('mitraData', 'setMitraData', {
  //   isFetching: true,
  //   list: [],
  // }),
  // withState('slideShowData', 'setSlideShowData', {
  //   isFetching: true,
  //   list: [],
  // }),
  withState('pageTracker', 'setPageTracker', {}),
  withState('videoTracker', 'setVideoTracker', {}),
  withState('helpCenterTracker', 'setHelpCenterTracker', {}),
  withState('searchInputTracker', 'setSearchInputTracker', {}),
  withState('searchSubmitTracker', 'setSearchSubmitTracker', {}),
  withHandlers({
    getPageTracker: (props) => async () => {
      const { setPageTracker } = props
      const previous_page_name = Cookies.get('page_name')
      Cookies.set('page_name', 'SCHOOL_PAGE', {
        path: '',
        sameSite: 'strict',
        secure: true,
      })

      try {
        const res = await props.ShootTracker('visit_page', {
          key: 'previous_page_name',
          value: previous_page_name,
        })
        setPageTracker(res)
      } catch (err) {
        setPageTracker({})
      }
    },
  }),
  withHandlers({
    clickVideo: (props) => async () => {
      const { setVideoTracker } = props
      try {
        const res = await props.ShootTracker('click_video')
        setVideoTracker(res)
      } catch (err) {
        setVideoTracker({})
      }
    },
  }),
  withHandlers({
    clickHelpCenter: (props) => async () => {
      const { setHelpCenterTracker } = props
      try {
        const res = await props.ShootTracker('click_help_center')
        setHelpCenterTracker(res)
      } catch (err) {
        setHelpCenterTracker({})
      }
    },
  }),
  withHandlers({
    typeSearchKeyword: (props) => async () => {
      const { setSearchInputTracker } = props
      try {
        const res = await props.ShootTracker('funnel_search_click')
        setSearchInputTracker(res)
      } catch (err) {
        setSearchInputTracker({})
      }
    },
  }),
  withHandlers({
    searchSubmit: (props) => async (keyword) => {
      const { setSearchSubmitTracker } = props
      try {
        const res = await props.ShootTracker('funnel_search_submit', {
          key: 'keyword',
          value: keyword,
        })
        setSearchSubmitTracker(res)
      } catch (err) {
        setSearchSubmitTracker({})
      }
    },
  }),
  withHandlers({
    // getList: props => async (params) => {
    //   const { setMitraData } = props
    //   try {
    //     const res = await props.webFetchPartners(params)
    //     setMitraData({
    //       isFetching: false,
    //       list: res,
    //     })
    //   } catch (err) {
    //     setMitraData({
    //       isFetching: false,
    //       list: [],
    //     })
    //   }
    // },
    // getSlideShowList: props => async (params) => {
    //   const { setSlideShowData } = props
    //   try {
    //     const res = await props.fetchWebSlideshow(params)
    //     setSlideShowData({
    //       isFetching: false,
    //       list: res,
    //     })
    //   } catch (err) {
    //     setSlideShowData({
    //       isFetching: false,
    //       list: [],
    //     })
    //   }
    // },
  }),
  lifecycle({
    componentDidMount() {
      this.props.getPageTracker()
      // this.props.getList()
      // this.props.getSlideShowList()
    },
  }),
)(SatuanPendidikans)
